// Legacy client dashboard redirect component
// Redirects /client/dashboard/:orgId/* to /dashboard/:orgId/*

import { Navigate, useParams, useLocation } from 'react-router-dom';

/**
 * Component that redirects legacy client dashboard URLs to the new unified dashboard
 * Preserves the path after /client/dashboard/:orgId
 */
export function LegacyClientRedirect() {
  const { orgId, '*': restPath } = useParams();
  const location = useLocation();

  // Build the new path
  const newPath = restPath
    ? `/dashboard/${orgId}/${restPath}`
    : `/dashboard/${orgId}`;

  // Preserve query params and hash
  const searchAndHash = location.search + location.hash;

  return <Navigate to={`${newPath}${searchAndHash}`} replace />;
}
